module.exports = __webpack_public_path__ + "img/account-meta4.1d69466e.png";